import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
} from 'reactstrap';
import classnames from 'classnames';

import { ROUTES, insertIdtoUrl } from 'constants/Routes.js';
import { BUSINESS_ADMIN_NAV } from 'constants/NavRoutes.js';

import { BusinessReports as Reports } from 'components/Business-admin/MenuRedirect';
import MeasureOfSuccess from 'components/dashboard/MeasureOfSuccess';
import CommentEmailReportConfig from 'components/businesses/tabs/reports/CommentEmailReportConfig';
import SurveyEmailReportConfig from 'components/businesses/tabs/reports/SurveyEmailReportConfig';
import TextSmsAlert from 'components/emailConfig/TextSmsAlert';
import FeedbackReports from 'components/feedbackReport/feedbackReports';

class BusinessDashboard extends Component {
  constructor(props) {
    super(props);

    const { match } = props;
    const { path: currentUrl } = match;

    this.state = {
      activeTab: currentUrl,
    };

    this.toggle = this.toggle.bind(this);
    this.checkTabToggle = this.checkTabToggle.bind(this);
  }

  componentDidMount() {
    this.checkTabToggle();
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  checkTabToggle() {
    const { match } = this.props;
    const { path: currentUrl } = match;
    const REPORT_ROUTES = BUSINESS_ADMIN_NAV.REPORT;

    if (ROUTES.DASHBOARD_INDEX == currentUrl) {
      this.setState({ activeTab: ROUTES.BUSINESS_DASHBOARD_INDEX });
    } else if (REPORT_ROUTES.includes(currentUrl)) {
      this.setState({ activeTab: ROUTES.REPORT_LIST });
    } else if (BUSINESS_ADMIN_NAV.FEEDBACK_REPORT.includes(currentUrl)) {
      this.setState({ activeTab: ROUTES.BUSINESS_SURVEY_FEEDBACKS });
    }
  }

  render() {
    const REPORT_ROUTES = BUSINESS_ADMIN_NAV.REPORT;
    const { match } = this.props;
    const { path: currentPath, params } = match;
    const businessId = params.id;

    return (
      <div>
        <div className="below-header pt-3">
          <div className="container">
            <Nav tabs>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={insertIdtoUrl(
                    ROUTES.BUSINESS_DASHBOARD_INDEX,
                    businessId
                  )}
                  className={`${classnames({
                    active: ROUTES.BUSINESS_DASHBOARD_INDEX === currentPath,
                  })}`}
                  onClick={() => {
                    this.toggle(ROUTES.BUSINESS_DASHBOARD_INDEX);
                  }}
                >
                  Measures of Success
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={insertIdtoUrl(ROUTES.REPORT_LIST, businessId)}
                  className={`${classnames({
                    active: REPORT_ROUTES.includes(currentPath),
                  })}`}
                  onClick={() => {
                    this.toggle(ROUTES.REPORT_LIST);
                  }}
                >
                  Survey Reports
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={insertIdtoUrl(
                    ROUTES.BUSINESS_SURVEY_EMAIL_CONFIG,
                    businessId
                  )}
                  className={`${classnames({
                    active: ROUTES.BUSINESS_SURVEY_EMAIL_CONFIG === currentPath,
                  })}`}
                  onClick={() => {
                    this.toggle(ROUTES.BUSINESS_SURVEY_EMAIL_CONFIG);
                  }}
                >
                  Survey Email
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={insertIdtoUrl(
                    ROUTES.BUSINESS_COMMENT_EMAIL_CONFIG,
                    businessId
                  )}
                  className={`${classnames({
                    active:
                      ROUTES.BUSINESS_COMMENT_EMAIL_CONFIG === currentPath,
                  })}`}
                  onClick={() => {
                    this.toggle(ROUTES.BUSINESS_COMMENT_EMAIL_CONFIG);
                  }}
                >
                  Comment Email
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={insertIdtoUrl(
                    ROUTES.BUSINESS_SMS_ALERT_CONFIG,
                    businessId
                  )}
                  className={`${classnames({
                    active: ROUTES.BUSINESS_SMS_ALERT_CONFIG === currentPath,
                  })}`}
                  onClick={() => {
                    this.toggle(ROUTES.BUSINESS_SMS_ALERT_CONFIG);
                  }}
                >
                  Text/Sms Alert
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={insertIdtoUrl(
                    ROUTES.BUSINESS_SURVEY_FEEDBACKS,
                    businessId
                  )}
                  className={`${classnames({
                    active: BUSINESS_ADMIN_NAV.FEEDBACK_REPORT.includes(
                      currentPath
                    ),
                  })}`}
                  onClick={() => {
                    this.toggle(ROUTES.BUSINESS_SURVEY_FEEDBACKS);
                  }}
                >
                  Feedback Reports
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>

        <div className="container">
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId={ROUTES.BUSINESS_DASHBOARD_INDEX}>
              <Row>
                <Col sm="12">
                  <MeasureOfSuccess />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={ROUTES.REPORT_LIST}>
              <Row>
                <Col sm="12">
                  <Reports />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={ROUTES.BUSINESS_SURVEY_EMAIL_CONFIG}>
              <Row>
                <Col sm="12">
                  <SurveyEmailReportConfig />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={ROUTES.BUSINESS_COMMENT_EMAIL_CONFIG}>
              <Row>
                <Col sm="12">
                  <CommentEmailReportConfig />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={ROUTES.BUSINESS_SMS_ALERT_CONFIG}>
              <Row>
                <Col sm="12">
                  <TextSmsAlert />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={ROUTES.BUSINESS_SURVEY_FEEDBACKS}>
              <Row>
                <Col sm="12">
                  <FeedbackReports />
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      </div>
    );
  }
}

BusinessDashboard.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
};

BusinessDashboard.defaultProps = {
  match: {
    path: '',
  },
};

export default withRouter(BusinessDashboard);



// WEBPACK FOOTER //
// ./src/containers/BusinessDashboard.js